import React from 'react';
import PropTypes from 'prop-types';

import Badge from "components/Badge";
import CircularProgress from "@mui/material/CircularProgress";

Status.propTypes = {
    errorCount: PropTypes.number,
    variationPercentage: PropTypes.number,
    hasEnded: PropTypes.bool
};

function Status({errorCount, variationPercentage, hasEnded = true}) {
    if (!hasEnded) {
        return (
            <Badge rounded>
                <CircularProgress size={10} />
                <span style={{marginLeft:'4px'}}>En cours</span>
            </Badge>
        )
    }

    if (errorCount === null || variationPercentage === null) {
        return null;
    }

    if (variationPercentage < 0 && errorCount > 0) {
        return <Badge rounded color={'error'}>À Corriger</Badge>
    }

    return <Badge rounded color={'online'}>Terminé</Badge>
}

export default Status;
